<script>
import Layout from "../../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../../app.config";

export default {
  page: {
    title: "Especificaciones sst adquisiciones",
    meta: [{ name: "especificaciones-sst-adquisiciones", content: appConfig.description }],
  },

  components: {
    Layout,
    PageHeader,
    Style,
  },

  data() {
    return {
      title: "",
      items: [
        {
          text: "Base de conocimiento",
          href: "/forms/general",
        },

        {
          text: "Especificaciones sst adquisiciones",
          active: true,
        },
      ],
      loading: true,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      companies_id: this.$store.getters["company/getCompany"].id || null,
    };
  },

  methods: {
    /**
     * Vuelve a la página anterior real. Esta vista se abre tanto desde la base
     * de conocimiento como desde su ítem, así que no se puede fijar el destino.
     * Si no hay historial (entrada directa o refresh) cae a la base de conocimiento.
     */
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push("/forms/general");
      }
    },

    /**
     * Scrollspy
     */
    scrollIntoView(evt) {
      evt.preventDefault();
      const href = evt.target.getAttribute("href");
      const el = href ? document.querySelector(href) : null;
      if (el) {
        this.$refs.content.scrollTop = el.offsetTop;
      }
    },
  },

}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />

    <div class="col-12">
      <div class="card">
        <div class="card-body">

          <div class="row">
            <div class="col-9">
              <h4 class="header-title">ESPECIFICACIONES EN SEGURIDAD Y SALUD EN EL TRABAJO PARA LAS ADQUISICIONES DE
                PRODUCTOS Y SERVICIOS</h4>
            </div>
            <div class="col-3 text-right">
              <button type="button" class="btn btn-secondary m-l-5 ml-1" id="tooltip" @click="goBack">
                <i class="fas fa-arrow-left"></i>
              </button>
              <b-tooltip target="tooltip" placement="left">Volver a la página anterior</b-tooltip>
            </div>
          </div>

          <br>

          <b-row>
            <p>
              <strong>OBJETIVO</strong>
            </p>
          </b-row>

          <b-row>
            <p>
              Garantizar que los suministros, materiales, equipo y contrataciones que se realicen para la empresa
              cumplan con los requisitos cumplimiento con requisitos de SG SST.
            </p>
          </b-row>

          <b-row>
            <p>
              <strong>DEFINICIONES</strong>
            </p>
          </b-row>

          <b-row>
            <ul>
              <li><strong>PROVEEDOR:</strong>
                Organización o persona que proporciona un producto.
              </li>
              <li><strong>PRODUCTO:</strong>
                Resultado de un conjunto de actividades mutuamente relacionadas o que interactúan, las cuales
                transforman elementos de entrada en resultados tangibles. 
              </li>
              <li><strong>SERVICIO:</strong>
                Actividad identificable e intangible que es objeto principal de una transacción ideada para brindar a
                los clientes satisfacción de deseos o necesidades.
              </li>
              <li><strong>CONTRATISTA:</strong>
                Es toda persona natural o jurídica (legalmente constituida) con autonomía técnica, administrativa y
                financiera, con quien la empresa contrata la ejecución de una labor o la prestación de un servicio.
              </li>
            </ul>
          </b-row>

          <b-row>
            <p>
              <strong>REQUISITOS DE SEGURIDAD Y SALUD EN EL TRABAJO:</strong>
            </p>
          </b-row>

          <b-row>
            <p>
              Todos los proveedores y contratistas deben cumplir con los siguientes requisitos:
            </p>
            <ul>
              <li>
                Certificado en el que conste que realizan el pago de la seguridad social.
              </li>
              <li>
                Certificado que conste la realización de la autoevaluación inicial del Sistema de Gestión de Seguridad y
                Salud en el Trabajo bajo la resolución 0312 de 2019. Este certificado debe incluir el porcentaje de
                calificación obtenido.
              </li>
            </ul>
          </b-row>

          <b-row>
            <p>
              Dependiendo del tipo de producto o servicio, deben cumplir con los siguientes requisitos adicionales:
            </p>
          </b-row>

          <b-row class="col-md-10">
            <table class="table table-bordered tg">
              <thead>
                <tr>
                  <th class="tg-9wq8"><strong>TIPO DE PRODUCTO / SERVICIO</strong></th>
                  <th class="tg-9wq8"><strong>REQUISITOS</strong></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="tg-9wq8">Equipo para trabajo seguro en alturas.</td>
                  <td class="tg-9wq9">
                    <ul>
                      <li>Ficha técnica.</li>
                      <li>Certificado de resistencia de alturas.</li>
                      <li>Compromiso de realización de inspección anual.</li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td class="tg-9wq8">Exámenes médicos ocupacionales.</td>
                  <td class="tg-9wq9">
                    <ul>
                      <li>Licencia de los médicos especialistas en Seguridad y Salud en el Trabajo.</li>
                      <li>Licencia del establecimiento que presta el servicio.</li>
                      <li>Certificado de calibración de los equipos.</li>
                      <li>Certificado de custodia de las historias clínicas ocupacionales.</li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td class="tg-9wq8">Elementos de protección personal.</td>
                  <td class="tg-9wq9">
                    <ul>
                      <li>Ficha técnica y manual.</li>
                      <li>Certificado de calidad.</li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td class="tg-9wq8">Herramientas manuales, eléctricas o no.</td>
                  <td class="tg-9wq9">Ficha técnica y manual.</td>
                </tr>
                <tr>
                  <td class="tg-9wq8">Productos químicos</td>
                  <td class="tg-9wq9">Ficha de datos de seguridad en idioma español con la identificación del SGA. Etiquetado de los productos conforme el SGA.</td>
                </tr>
                <tr>
                  <td class="tg-9wq8">Mobiliario para oficinas</td>
                  <td class="tg-9wq9">
                    Mobiliario, para definir a mesa de trabajo se deberán tener en cuenta:
                    <ul>
                      <li>Si la altura es fija, ésta será de aproximadamente 70cm.</li>
                      <li>Si la altura es regulable, la amplitud de regulación estará entre 68 y 70 cm.</li>
                      <li>a superficie mínima será de 120 cm de ancho y 80 cm de largo. (Dependiendo del diseño que se realice del área de trabajo).</li>
                      <li>El espesor no debe ser mayor de 30 cm.</li>
                      <li>La superficie será de material mate y color claro suave, rechazándose las superficies brillantes y oscuras.</li>
                      <li>Permitirá la colocación y los cambios de posición de las piernas.</li>
                    </ul>
                    El asiento responderá a las características siguientes:
                    <ul>
                      <li>Regulable en altura (en posición sentado) margen ajuste entre 38 y 50 cm.</li>
                      <li>Anchura entre 40 - 45 cm.</li>
                      <li>Profundidad entre 38 y 42 cm.</li>
                      <li>Acolchado de 20 cm recubierto con tela flexible y transpirable.</li>
                    </ul>
                    Borde anterior inclinado (gran radio de inclinación). 
                  </td>
                </tr>
                <tr>
                  <td class="tg-9wq8">Centros de entrenamiento para alturas</td>
                  <td class="tg-9wq9">Registro ante el Ministerio.</td>
                </tr>
                <tr>
                  <td class="tg-9wq8">Centros de entrenamiento para espacios confinados</td>
                  <td class="tg-9wq9">Registro ante el Ministerio.</td>
                </tr>
                <tr>
                  <td class="tg-9wq8">Construcción</td>
                  <td class="tg-9wq9">
                    <ul>
                      <li>Certificado para realizar trabajo en alturas.</li>
                      <li>Certificado del Coordinador para trabajo seguro en alturas.</li>
                      <li>Permiso para tareas de alto riesgo.</li>
                      <li>Certificación de espacios confinados.</li>
                      <li>Hojas de vida y fichas técnicas de los equipos.</li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td class="tg-9wq8">Mantenimiento</td>
                  <td class="tg-9wq9">
                    <ul>
                      <li>Certificado para realizar trabajo en alturas.</li>
                      <li>Certificado del Coordinador para trabajo seguro en alturas.</li>
                      <li>Permiso para tareas de alto riesgo.</li>
                      <li>Certificación de espacios confinados.</li>
                      <li>Hojas de vida y fichas técnicas de los equipos.</li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td class="tg-9wq8">Fumigación</td>
                  <td class="tg-9wq9">Certificado de aplicador de plaguicidas.</td>
                </tr>
                <tr>
                  <td class="tg-9wq8">Transporte</td>
                  <td class="tg-9wq9">
                    <ul>
                      <li>Certificado de implementación del Plan Estratégico de Seguridad Vial.</li>
                      <li>Revisión técnico-mecánica.</li>
                      <li>SOAT.</li>
                      <li>Póliza responsabilidad civil.</li>
                      <li>HInspección preoperacional del vehículo.</li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td class="tg-9wq8">Trabajos eléctricos</td>
                  <td class="tg-9wq9">
                    <ul>
                      <li>Matrícula profesional del electricista.</li>
                      <li>Elementos de protección personal dieléctricos.</li>
                      <li>Dispositivos de bloqueo.</li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </b-row>

        </div>
      </div>
    </div>

  </Layout>
</template>

<style type="text/css">
.table-bordered {
  border: 1px solid #dcdce7;
}

.tg .tg-9wq8 {
  border-color: inherit;
  text-align: center;
  vertical-align: middle
}

.tg .tg-9wq9 {
  border-color: inherit;
}

.tg .tg-nrix {
  text-align: center;
  vertical-align: middle
}
</style>